import { cn } from "@/lib/utils";
import cloud1 from "@/assets/cloud-1.png";
import cloud2 from "@/assets/cloud-2.png";
import cloud5 from "@/assets/cloud-5.png";
import cloud7 from "@/assets/cloud-7.png";

export type SectionCloudsVariant =
  "audiences" | "services" | "process" | "benefits" | "pricing" | "team" | "faq" | "case-study";

interface Placement {
  src: string;
  side: "left" | "right";
  topPct?: number;
  offsetPct: number;
  opacity: number;
  maxWidth?: number;
  bottomPct?: number;
}

const VARIANTS: Record<SectionCloudsVariant, Placement[]> = {
  audiences: [
    // { src: cloud1, side: "left", topPct: 10, offsetPct: -8, opacity: 1 },
    {
      src: cloud1,
      side: "left",
      bottomPct: -10,
      offsetPct: -20,
      opacity: 0.4,
      // maxWidth: 1000,
    },
  ],
  services: [
    {
      src: cloud5,
      side: "right",
      topPct: 3,
      offsetPct: -20,
      opacity: 0.34,
      maxWidth: 700,
    },
    // {
    //   src: cloud2,
    //   side: "right",
    //   topPct: 10,
    //   offsetPct: 5,
    //   opacity: 0.6,
    //   maxWidth: 400,
    // },
    // { src: cloud8, side: "right", topPct: 30, offsetPct: -7, opacity: 0.3 },
  ],
  process: [
    { src: cloud7, side: "left", bottomPct: 0, offsetPct: -11, opacity: 0.35 },
    // { src: cloud5, side: "right", topPct: 0, offsetPct: -8, opacity: 0.28 },
  ],
  benefits: [
    // { src: cloud7, side: "left", topPct: 0, offsetPct: -10, opacity: 0.36 },
    { src: cloud7, side: "right", bottomPct: 0, offsetPct: -13, opacity: 0.4 },
  ],
  pricing: [
    // { src: cloud4, side: "right", topPct: 15, offsetPct: -9, opacity: 0.32 },
    // { src: cloud2, side: "left", topPct: 0, offsetPct: -7, opacity: 0.28 },
    // { src: cloud6, side: "right", topPct: 0, offsetPct: -5, opacity: 0.3 },
  ],
  team: [
    // { src: cloud7, side: "left", bottomPct: 0, offsetPct: -10, opacity: 0.4 },
    { src: cloud2, side: "right", topPct: 5, offsetPct: -8, opacity: 0.4 },
  ],
  faq: [
    // { src: cloud5, side: "right", topPct: 0, offsetPct: -11, opacity: 0.32 },
    { src: cloud7, side: "left", bottomPct: 0, offsetPct: -9, opacity: 0.36 },
  ],
  "case-study": [
    {
      src: cloud2,
      side: "right",
      topPct: 0,
      offsetPct: -10,
      opacity: 0.4,
      maxWidth: 700,
    },
  ],
};

const CLOUD_WIDTH_PCT = 70;

export function SectionClouds({ variant }: { variant: SectionCloudsVariant }) {
  const placements = VARIANTS[variant];

  return (
    <div
      aria-hidden
      className={cn(
        "section-clouds-host pointer-events-none absolute z-0 overflow-hidden",
        "hidden md:block",
      )}
      // Extend horizontally past the .frame edges (.page has 10px padding) so clouds reach the viewport edges.
      style={{ top: 0, bottom: 0, left: -10, right: -10 }}
    >
      {placements.map((p, i) => (
        <img
          key={i}
          src={p.src}
          alt=""
          loading="lazy"
          decoding="async"
          style={{
            position: "absolute",
            maxWidth: `${p.maxWidth ?? 800}px`,
            top: `${p.topPct ?? "none"}%`,
            [p.side]: `${p.offsetPct}%`,
            width: `${CLOUD_WIDTH_PCT}%`,
            opacity: p.opacity,
            bottom: `${p.bottomPct ?? "none"}%`, // Ensure clouds don't exceed the section height
          }}
        />
      ))}
    </div>
  );
}
